import { render, staticRenderFns } from "./order-result.vue?vue&type=template&id=a3023d58"
import script from "./order-result.vue?vue&type=script&lang=js"
export * from "./order-result.vue?vue&type=script&lang=js"
import style0 from "./order-result.vue?vue&type=style&index=0&id=a3023d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports